(function () {
  'use strict';

  // Links the main product photo gallery to the variant picker: swiping/scrolling
  // to a photo that belongs to a specific variant (e.g. a Pattern) auto-selects
  // that variant, so "Add to cart" always adds whichever photo is on screen.
  // No-ops safely if a product has no per-variant images, or if the gallery/
  // variant markup this depends on isn't present.

  function init(section) {
    if (!section || section.dataset.gallerySyncInit) return;

    var mainSlider = section.querySelector('[data-product-photos]');
    var variantJsonEl = section.querySelector('[data-variant-json]');
    if (!mainSlider || !variantJsonEl) return;

    var variants;
    try {
      variants = JSON.parse(variantJsonEl.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variants) || variants.length < 2) return;

    var mediaIdToVariant = {};
    variants.forEach(function (variant) {
      if (variant.featured_media && variant.featured_media.id) {
        mediaIdToVariant[variant.featured_media.id] = variant;
      }
    });
    // Only worth wiring up if at least two variants actually have distinct images.
    if (Object.keys(mediaIdToVariant).length < 2) return;

    section.dataset.gallerySyncInit = 'true';

    function selectVariantForMedia(mediaId) {
      var variant = mediaIdToVariant[mediaId];
      if (!variant) return;

      ['option1', 'option2', 'option3'].forEach(function (key) {
        var value = variant[key];
        if (value == null) return;
        var input = section.querySelector(
          '[data-variant-input][data-index="' + key + '"][value="' + String(value).replace(/"/g, '\\"') + '"]'
        );
        if (input && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    function bind(attemptsLeft) {
      var flkty = window.Flickity && window.Flickity.data(mainSlider);
      if (!flkty) {
        if (attemptsLeft > 0) {
          setTimeout(function () { bind(attemptsLeft - 1); }, 300);
        }
        return;
      }
      flkty.on('settle', function (index) {
        var slides = mainSlider.querySelectorAll('.product-main-slide');
        var slideEl = slides[index];
        if (!slideEl) return;
        var mediaId = slideEl.getAttribute('data-media-id');
        if (mediaId) selectVariantForMedia(mediaId);
      });
    }

    bind(10);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('.product-section[data-section-type="product"]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-bind if the theme editor reloads this section.
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
